import type { I18nFn } from 'i18n/types/I18nFn';

export enum EmploymentType {
  FULL_TIME = 'FULL_TIME',
  PART_TIME = 'PART_TIME',
  TEMPORARY = 'TEMPORARY',
  CONTRACT = 'CONTRACT',
}

export function EMPLOYMENT_TYPES(i18n: I18nFn) {
  return {
    [EmploymentType.FULL_TIME]: i18n('Full-Time Employee'),
    [EmploymentType.PART_TIME]: i18n('Part-Time Employee'),
    [EmploymentType.TEMPORARY]: i18n('Temporary'),
    [EmploymentType.CONTRACT]: i18n('Contract/Freelance'),
  };
}

export const EMPLOYMENT_TYPE_CHECKBOX_OPTIONS = (i18n: I18nFn) =>
  Object.entries(EMPLOYMENT_TYPES(i18n)).map(([key, value]) => ({
    name: key,
    label: value,
  }));

export const EMPLOYMENT_TYPE_RADIO_OR_SELECT_OPTIONS = (i18n: I18nFn) =>
  Object.entries(EMPLOYMENT_TYPES(i18n)).map(([key, value]) => ({
    value: key,
    label: value,
  }));
